import {
  Col,
  Form, message,
  Row,
  Skeleton, Switch,
  Typography
} from "antd";
import { FormComponent } from "components/BaseComponent";
import { ShelterSponsorMeForm } from "components/Forms/ShelterSettings";
import { LanguageConsumer } from "context/LanguageContext";
import { ShelterContextData } from "context/ShelterContext";
import { ShelterSettingContextData } from "context/ShelterSettingContext";
import IShelter from "interfaces/IShelter";
import IShelterSponsor from "interfaces/IShelterSponsor";
import React from "react";
import { ShelterSettingPetProfileSaveRequest, ShelterSettingSponsorSaveRequest } from "services/api/interfaces/ApiRequest";

type PetProfileProps = {
  uuid: string;
  context: ShelterContextData;
  settingsContext: ShelterSettingContextData;
  data: IShelter;
  shelterSponsorSettings: IShelterSponsor | null;
  dispatchSaveSponsorSetting: (args: ShelterSettingSponsorSaveRequest) => Promise<any>
  
};

export default class PetProfile extends FormComponent<PetProfileProps> {
  state = {
    loaded: false,
    initialValues: {},
    fieldValues: {
      allow_adoption: {
        in_foster: true,
        in_shelter: true,
        type_key_lost: true,
        type_key_found: true
      },
    } as any,
  };

  form: any;

  async componentDidMount() {
    const { uuid, settingsContext } = this.props;

    if (uuid && !settingsContext.fetching) {
      await settingsContext.requestShelterSettingList({
        search: {
          organization_shelter: {
            has: {
              uuid,
            },
          },
        },
      });
    }
    const fetchedAllowAdoption = this.getValues()?.allow_adoption;
    const allowAdoption = {
      ...this.state.fieldValues.allow_adoption,
      ...fetchedAllowAdoption,
    };

    this.setState({
      loaded: true,
      initialValues: allowAdoption,
      fieldValues: {
        allow_adoption: allowAdoption,
      },
    });
  }

  private getValues = () => {
    const { settingsContext } = this.props;

    const values = settingsContext.shelterSettings?.find(
      (v) => v.type_key === "PET_PROFILE"
    )?.value as any;
    return values;
  };

  private handleSave = async (values: any) => {

    const { uuid, settingsContext , dispatchSaveSponsorSetting} = this.props;
    const sponsor = values.shelter_setting?.sponsor || null

    let sponsorSetting = {} as any


    if (sponsor) {
      Object.keys(sponsor).forEach(key => {
        if (sponsor[key] !== undefined) {
          // Parse sponsor settings translation
          if (key === 'translation') {
            sponsorSetting[key] = values.shelter_setting.sponsor[key].map(p => {
              return {
                language_uuid: p.language,
                value: {
                  ...p.value,
                  enabled: values.shelter_setting.sponsor.enabled
                }
              }
            })
          } else {
            sponsorSetting[key] = sponsor[key]
          }
        }
      })
    }

    try {
      if (Object.keys(sponsorSetting).length) {
        await dispatchSaveSponsorSetting({
          shelter_uuid: uuid,
          type_key: 'SPONSOR',
          value: sponsorSetting,
          translation: sponsorSetting.translation || []
        })
      }


      const payload: ShelterSettingPetProfileSaveRequest = {
        shelter_uuid: uuid,
        type_key: "PET_PROFILE",
        value: {
          allow_adoption: this.state.fieldValues.allow_adoption,
        },
      };

      await settingsContext.requestShelterSettingPetProfileSave(payload);
      message.success("Pet profile saved successfully!");
    } catch (error) {
      message.error(`Failed to save pet profile. Reason: ${error}`);
    }
  };

  private handleChange = async (values: any[], allValues?: any[]) => {
    const { allow_adoption } = this.state.fieldValues;
    for await (const v of values) {
      const fieldName = v.name[0];
      allow_adoption[fieldName] = v?.value;
    }
    this.setState({
      fieldValues: {
        allow_adoption,
      },
    });
  };

  render() {
    const { loaded, initialValues } = this.state;

    if (!loaded) {
      return <Skeleton />;
    }

    const values = {
      ...initialValues,
      shelter_setting: {
        sponsor: {
          enabled: true,
          btnText: "My Wishlist",
          ...(this.props.shelterSponsorSettings
            ? {
                ...this.props.shelterSponsorSettings,
                translation:
                  this.props.shelterSponsorSettings.translation?.map((p) => {
                    return {
                      language: p.language_uuid,
                      value: p.value,
                    };
                  }) || [],
              }
            : {}),
        } as any,
      },
    };


    return (
      <div>
        <Form
          name="pet_profile"
          layout="vertical"
          initialValues={values}
          ref={(ref) => {
            if (!this.form) {
              this.form = ref;
              this.forceUpdate();
            }
          }}
          onFinish={this.handleSave}
          onFieldsChange={this.handleChange}
          style={{ width: "100%" }}
        >
          <Row gutter={24}>
            <Col xs={24} sm={12} md={12}>
              <Typography.Title level={5}>
                Configuration of Adopt Me CTA
              </Typography.Title>
              <Typography.Text>
                Allows the Adopt Me CTA removal for In Shelter and In Foster
                pets separately. Example: this can be common for shelters that
                want to receive online adoption inquiries for animals that are
                In Foster but want In Shelter animals to receive
                inquiries/applications directly from adopters scanning the
                Adopets smart kennel card.
              </Typography.Text>
              <br />
              <br />
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    label="In Shelter"
                    name={["in_shelter"]}
                    valuePropName="checked"
                  >
                    <Switch />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    label="In Foster"
                    name={["in_foster"]}
                    valuePropName="checked"
                  >
                    <Switch />
                  </Form.Item>
                </Col>
              </Row>
              <LanguageConsumer>
                {({ fetching, languages, requestLanguageList }) => {
                  return this.form ? (
                    <ShelterSponsorMeForm
                      form={this.form}
                      contentLoading={fetching}
                      shelter={this.props.data}
                      languages={languages}
                      loadLanguages={requestLanguageList}
                    />
                  ) : null;
                }}
              </LanguageConsumer>
            </Col>
            <Col xs={24} sm={12} md={12}>
              <Typography.Title level={5}>
                Configuration of CLAIM CTA
              </Typography.Title>
              <Typography.Text>
                Extends CTA removal controls to Lost and Found pets. In addition to configuring the Adopt Me button for In Shelter and In Foster animals, organizations can now remove the 'This is My Pet' button from Lost and/or Found pet profiles — useful for shelters that prefer to handle owner reunification inquiries through direct contact rather than the standard claim flow.
              </Typography.Text>
              <br />
              <br />
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    label="LOST"
                    name={["type_key_lost"]}
                    valuePropName="checked"
                  >
                    <Switch />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    label="FOUND"
                    name={["type_key_found"]}
                    valuePropName="checked"
                  >
                    <Switch />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>

         
        </Form>
      </div>
    );
  }
}
